import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Printer({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Printer</title>
      <path
        d="M7 6C7 4.89543 7.89543 4 9 4H15C16.1046 4 17 4.89543 17 6V8H7V6Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14H17V18C17 19.1046 16.1046 20 15 20H9C7.89543 20 7 19.1046 7 18V14Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 17V17.75C21.4142 17.75 21.75 17.4142 21.75 17H21ZM3 17H2.25C2.25 17.4142 2.58579 17.75 3 17.75V17ZM18 16.25C17.5858 16.25 17.25 16.5858 17.25 17C17.25 17.4142 17.5858 17.75 18 17.75V16.25ZM6 17.75C6.41421 17.75 6.75 17.4142 6.75 17C6.75 16.5858 6.41421 16.25 6 16.25V17.75ZM5 8.75H19V7.25H5V8.75ZM20.25 10V17H21.75V10H20.25ZM3.75 17V10H2.25V17H3.75ZM21 16.25H18V17.75H21V16.25ZM6 16.25H3V17.75H6V16.25ZM19 8.75C19.6904 8.75 20.25 9.30964 20.25 10H21.75C21.75 8.48122 20.5188 7.25 19 7.25V8.75ZM5 7.25C3.48122 7.25 2.25 8.48122 2.25 10H3.75C3.75 9.30964 4.30964 8.75 5 8.75V7.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M18 11L16 11"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
